export const serverProduction = {
    allowComment: true,
    allowExplore: true,
    allowMessage: true,
    allowRegister: true,
    allowSearch: true,
    allowSubscription: false,
    allowUpload: true,
    cacheAccountTtlMs: 600000, // min: an account's username (added to every user object, and the /@username lookup) per isolate and colo (a rename shows up after this); 0 = off
    cacheAccountTtlMaxMs: 600000, // longest TTL of cacheAccountTtlMs, used at a 0% hit rate (falls linearly to the min at 100%); equal to it = fixed; 0 = off
    cacheCandidateTtlMs: 600000, // min: feed/explore candidate pool, anchor and user vectors; 0 = off
    cacheCandidateTtlMaxMs: 1800000, // longest TTL of cacheCandidateTtlMs, used at a 0% hit rate (falls linearly to the min at 100%); equal to it = fixed; 0 = off
    cacheConfigTtlMs: 60000, // shared (per colo) config poll read; applies at isolate start; 0 = off
    cacheFilterTtlMs: 3600000, // min: filter lists and options (admin changes show up after this); 0 = off
    cacheFilterTtlMaxMs: 86400000, // longest TTL of cacheFilterTtlMs, used at a 0% hit rate (falls linearly to the min at 100%); equal to it = fixed; 0 = off
    cachePostStatTtlMs: 30000, // min: post view/like/comment counters per isolate; 0 = off
    cachePostStatTtlMaxMs: 120000, // longest TTL of cachePostStatTtlMs, used at a 0% hit rate (falls linearly to the min at 100%); equal to it = fixed; 0 = off
    cachePostTtlMs: 60000, // min: post_get body + author per colo (block/delete shows up after this); 0 = off
    cachePostTtlMaxMs: 60000, // longest TTL of cachePostTtlMs, used at a 0% hit rate (falls linearly to the min at 100%); equal to it = fixed; 0 = off
    cacheProfileCountTtlMs: 1800000, // min: follower/following counts on others' profiles per colo; 0 = off
    cacheProfileCountTtlMaxMs: 1800000, // longest TTL of cacheProfileCountTtlMs, used at a 0% hit rate (falls linearly to the min at 100%); equal to it = fixed; 0 = off
    cacheProfileImageTtlMs: 600000, // min: a user's profile_images row (picture, thumbnail, moderation state) per isolate and colo (a changed or newly moderated picture shows up after this); 0 = off
    cacheProfileImageTtlMaxMs: 600000, // longest TTL of cacheProfileImageTtlMs, used at a 0% hit rate (falls linearly to the min at 100%); equal to it = fixed; 0 = off
    cacheProfileTtlMs: 600000, // min: others' profile body per colo; 0 = off
    cacheProfileTtlMaxMs: 1800000, // longest TTL of cacheProfileTtlMs, used at a 0% hit rate (falls linearly to the min at 100%); equal to it = fixed; 0 = off
    cacheTrendingTtlMs: 3600000, // min: trending page and trending vector per colo (ranks change weekly); 0 = off
    cacheTrendingTtlMaxMs: 21600000, // longest TTL of cacheTrendingTtlMs, used at a 0% hit rate (falls linearly to the min at 100%); equal to it = fixed; 0 = off
    cacheUserTtlMs: 600000, // min: users rows (comment/search/profile authors, and the status check on writes) per isolate and colo (a ban/rename shows up after this); 0 = off
    cacheUserTtlMaxMs: 600000, // longest TTL of cacheUserTtlMs, used at a 0% hit rate (falls linearly to the min at 100%); equal to it = fixed; 0 = off
    cacheRestrictionTtlMs: 600000, // a user's own comment/upload restriction per isolate and colo, none is cached too (a new one shows up within about 2x this; an expired one applies at once); 0 = off
    cacheStatsEnabled: false, // true = every loise isolate writes its cache hit counts to D1 (admin Loise > Cache > Command > Start/Stop); false = no D1 writes
    commentDescMax: 2048,
    configPollIntervalMs: 60000,
    conversationPageSize: 20, // conversations per page in the conversation list
    exploreCandidates: 250,
    exploreDiscoveryDist: 0.3,
    exploreMaxPerUser: 2,
    favoriteMax: 300,
    feedCandidates: 250,
    followingMax: 100,
    legalNoticeVersion: 1, // 0 = hide; bump to show a new notice
    legalPrivacyVersion: 1,
    legalTermsVersion: 1,
    loiseSystemUserId: '019e8285-df46-7196-8800-c715c19b197b',
    maintenance: false,
    messageExpireMs: 30 * 24 * 60 * 60 * 1000, // 30 days
    messageListPageSize: 30, // messages per page inside a conversation
    messageMax: 2000,
    mlBatchSizeImageEmbedding: 1, // items per batch sent to a siglip2 box
    mlBatchSizeImageModeration: 1, // items per batch sent to a nudenet-image box
    mlBatchSizeTextModeration: 50, // items per batch sent to a bert-small-toxicity box (max 90)
    mlBatchSizeVideoModeration: 1, // items per batch sent to a nudenet-video box
    nudenetAnusMinBoxPct: 0.5, // ANUS_EXPOSED: min box area (% of image) to count — filters tiny false positives
    nudenetAnusReviewScore: 0.35, // ANUS_EXPOSED: censor at this score
    nudenetBreastMinBoxPct: 0.5, // FEMALE_BREAST_EXPOSED: min box area (% of image) to count — filters tiny false positives
    nudenetBreastReviewScore: 0.35, // FEMALE_BREAST_EXPOSED: censor at this score
    nudenetGenitaliaMinBoxPct: 0.5, // FEMALE_GENITALIA_EXPOSED: min box area (% of image) to count — filters tiny false positives
    nudenetGenitaliaReviewScore: 0.35, // FEMALE_GENITALIA_EXPOSED: censor at this score
    postDescMax: 2048,
    profileDescMax: 1024,
    signupEmailMax: 254,
    signupMinAge: 16,
    signupPasswordMax: 128,
    signupUsernameMax: 30,
    restrictionLevelBanMs: [
        24 * 60 * 60 * 1000, // level 1: 24h — warning
        7 * 24 * 60 * 60 * 1000, // level 2: 7d
        14 * 24 * 60 * 60 * 1000, // level 3: 14d
        30 * 24 * 60 * 60 * 1000, // level 4+: 30d
    ],
    restrictionLevelDecayMs: 30 * 24 * 60 * 60 * 1000, // 30d — level decay period
    textToxicThreshold: 0.5, // text moderation: censor at this toxicity score (bert-small-toxicity)
    tagNewMs: 7 * 24 * 60 * 60 * 1000, // 7 days
    trendingCap: 100,
    trendingTagTop: 5, // top-N per demographic bucket get the TRENDING tag
    userListPageSize: 20,
};
